import React from 'react'
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const DeleteDialog = ({ isActive, closeDialog, deletePermanently = false }) => {
    const {
        deleteDashboard,
    } = useDashboardDomainContext();

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            title={deletePermanently ? "Delete Dashboard" : "Hide Dashboard"}
            okText={deletePermanently ? "Delete" : "Hide"}
            onOk={async () => {
                closeDialog();
                await deleteDashboard(deletePermanently);
            }}
            onCancel={() => {
                closeDialog();
            }}
        >
            <div className="dialog-text">
                {deletePermanently
                    ? "Please confirm that you want to permanently delete this dashboard."
                    : "Please confirm that you want to hide this dashboard."}
            </div>
        </DialogControl>
    )
}

export default DeleteDialog
